exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".generic-page-error{padding:4rem 0;text-align:center;width:100%}.generic-page-error h2{font-size:2.5rem}.generic-page-error .error-details-header{display:block;font-size:1.5rem;font-style:italic;font-weight:600}.generic-page-error .error-description-line{display:block;font-size:1.25rem;font-weight:600;line-height:120%;max-width:600px;overflow-wrap:break-word;padding:.2rem}.generic-page-error .error-flex-margin{margin:1rem 0;max-width:100%}.generic-page-error .error-icon{max-width:15rem;min-width:5rem}.generic-page-error .error-text-color{color:#c35b5b}.generic-page-error .grey-top-border{border-top:1px solid #a5a6aa}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/components/PageError/PageError.scss
// module id = 873
// module chunks = 0